import { fetchSensors } from 'app/business-logic/services/monitor-service/fetchSensors';
import Guid from 'core/types/Guid';
import { IMonitorInfluenceArcData } from './types';
import { fetchMonitorData } from 'app/business-logic/services/monitor-service/fetch-influence-arc-data-for-monitors/fetchMonitorData';
import { IAlertPointDataWithMonitor } from '../../modelling-service/types';

export async function fetchInfluenceArcDataForMonitors(
  monitorIds: Guid[],
  utcDateTime: string,
  selectedSensorGroup: Guid
): Promise<IMonitorInfluenceArcData[]> {
  const data: IAlertPointDataWithMonitor[] = await fetchMonitorData(monitorIds, utcDateTime, selectedSensorGroup);
  const processVariableIds = data?.flatMap(({ processVariable }) => {
    if (!processVariable) return [];
    return processVariable.id;
  });
  const windSpeedUnits = await fetchWindSpeedUnits(processVariableIds);
  return data?.flatMap(({ influenceArc, monitor, processVariable }) => {
    if (!processVariable) return [];
    const windSpeedUnit = windSpeedUnits.get(processVariable.id) ?? '-';
    return influenceArc
      ? {
          monitorId: monitor.id,
          windSpeedUnit: windSpeedUnit,
          measurements: {
            speed: influenceArc.windSpeed,
            direction: influenceArc.windDirection,
            sigmaTheta: influenceArc.sigmaTheta,
            speedInBaseUnit: influenceArc.windSpeed,
          },
        }
      : [];
  }) as IMonitorInfluenceArcData[];
}

async function fetchWindSpeedUnits(sensorIds: Guid[]): Promise<Map<Guid, string>> {
  const sensors = await fetchSensors(sensorIds);
  const unitsBySensorId = Array.from(sensors.entries()).map(([, sensor]) => [sensor.id, sensor.unitName] as const);
  return new Map(unitsBySensorId);
}
